const DefinitionTypes = {
  NEW: "new",
  EDITED: "edited",
  MD: "md"
};

export default DefinitionTypes;
